import React, { useState, useEffect } from 'react';
import { Globe, ArrowUpDown, ArrowRight, BarChart2, Phone, Mail, MapPin, ChevronDown, Menu, X, Briefcase, TrendingUp, Shield } from 'lucide-react';
import service1 from '../assets/importexport.png'
import service2 from '../assets/marketanalysis.jpg'
import Header from '../components/Header';
import hero4 from '../assets/heroimport.jpg'
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import silverbar from '../assets/silverbar.jpg'
import silvercoin from '../assets/silvercoin.png'
import silverjwellery from '../assets/silverjwellery.png'
import goldbar from '../assets/goldbar.png'
import goldcoin from '../assets/goldcoin.png'
import goldjwellery from '../assets/goldjwellery.png' 
const GoldSilverWebsite = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeServiceTab, setActiveServiceTab] = useState('gold');
  const [activeTab, setActiveTab] = useState('all');
  const [scrolled, setScrolled] = useState(false);
  const [goldPrice, setGoldPrice] = useState(2342.80);
  const [silverPrice, setSliderPrice] = useState(27.65);
  
  // Handle scroll effect for navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Simulate live price updates
  useEffect(() => {
    const interval = setInterval(() => {
      setGoldPrice(prev => +(prev + (Math.random() * 2 - 1) * 0.5).toFixed(2));
      setSliderPrice(prev => +(prev + (Math.random() * 2 - 1) * 0.1).toFixed(2));
    }, 5000);
    
    return () => clearInterval(interval);
  }, []);

  const services = [
    {
      id: 1,
      title: "Import & Export",
      description: "Seamless cross-border precious metals trading with full compliance and logistics support.",
      icon: <ArrowUpDown />,
      category: "trading",
      featured: true
    },
    {
      id: 2,
      title: "Market Analysis",
      description: "Expert insights and real-time market data to inform your precious metals investment decisions.",
      icon: <BarChart2 />,
      category: "analysis",
      featured: true
    },
    {
      id: 3,
      title: "Global Logistics",
      description: "Secure transportation, storage, and handling of precious metals with comprehensive insurance.",
      icon: <Globe />,
      category: "logistics",
      featured: true
    },
    {
      id: 4,
      title: "Compliance Consulting",
      description: "Navigate complex regulatory frameworks with our specialized compliance consulting services.",
      icon: <Shield />,
      category: "consulting"
    },
    {
      id: 5,
      title: "Investment Advisory",
      description: "Personalized investment strategies for high-net-worth individuals and institutional investors.",
      icon: <TrendingUp />,
      category: "analysis"
    },
    {
      id: 6,
      title: "Industry Research",
      description: "Comprehensive research reports on precious metals markets, trends, and forecasts.",
      icon: <Briefcase />,
      category: "analysis"
    }
  ];

  const filteredServices = activeTab === 'all' 
    ? services 
    : services.filter(service => service.category === activeTab);

  
  return (
    <>
       <Header />
   
    <div className="flex flex-col min-h-screen bg-gray-50">
      {/* Navigation */}
  
      {/* Hero Section */}
      <section className="pt-24 pb-16 md:pt-32 md:pb-24 bg-gradient-to-r from-gray-900 to-gray-800 text-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center">
            <div className="md:w-1/2 mb-10 md:mb-0">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-yellow-400">Global</span> Gold & Silver <br />
                <span className="text-yellow-400">Import & Export</span> Solutions
              </h1>
              <p className="text-lg text-gray-300 mb-8">
                Industry leading precious metals trading with secure, reliable, and competitive services for businesses worldwide.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link to='/services'>
                <button className="bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-3 px-6 rounded transition-colors">
                  Our Services
                </button>
                </Link>

                <Link to='/contact'>
                <button className="bg-transparent border border-yellow-600 hover:bg-yellow-600/10 text-white font-medium py-3 px-6 rounded transition-colors">
                  Contact Us
                </button>
                </Link>
              </div>
            </div>
            <div className="md:w-1/2 relative">
              <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-1 rounded-lg shadow-2xl">
                <img src={hero4} alt="Gold bars and silver coins" className="rounded-lg" />
              </div>
              <div className="absolute -bottom-8 -left-8 bg-white text-black p-4 rounded-lg shadow-lg">
                <div className="flex items-center gap-2">
                  <ArrowUpDown className="text-yellow-600" />
                  <span className="font-bold">24/7 Market Trading</span>
                </div>
              </div>
              <div className="absolute -top-8 -right-8 bg-white text-black p-4 rounded-lg shadow-lg">
                <div className="flex items-center gap-2">
                  <Globe className="text-yellow-600" />
                  <span className="font-bold">Global Operations</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Stats Section */}
      {/* <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="flex flex-col items-center p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-shadow">
              <span className="text-4xl font-bold text-yellow-600">25+</span>
              <span className="text-gray-700 mt-2">Years Experience</span>
            </div>
            <div className="flex flex-col items-center p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-shadow">
              <span className="text-4xl font-bold text-yellow-600">42</span>
              <span className="text-gray-700 mt-2">Countries Served</span>
            </div>
            <div className="flex flex-col items-center p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-shadow">
              <span className="text-4xl font-bold text-yellow-600">$2.8B</span>
              <span className="text-gray-700 mt-2">Annual Trade Volume</span>
            </div>
            <div className="flex flex-col items-center p-6 border border-gray-200 rounded-lg hover:shadow-lg transition-shadow">
              <span className="text-4xl font-bold text-yellow-600">99.9%</span>
              <span className="text-gray-700 mt-2">Client Satisfaction</span>
            </div>
          </div>
        </div>
      </section> */}

      
      {/* Services Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Our Premium Services</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Choose from our wide range of specialized services designed to meet all your precious metals trading needs.
            </p>
          </div>
          
          <div className="flex flex-wrap justify-center gap-2 mb-12">
            <button 
              onClick={() => setActiveTab('all')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'all' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              All Services
            </button>
            <button 
              onClick={() => setActiveTab('trading')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'trading' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Trading
            </button>
            <button 
              onClick={() => setActiveTab('analysis')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'analysis' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Analysis
            </button>
            <button 
              onClick={() => setActiveTab('logistics')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'logistics' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Logistics
            </button>
            <button 
              onClick={() => setActiveTab('consulting')}
              className={`px-6 py-2 rounded-full font-medium transition-colors ${
                activeTab === 'consulting' 
                  ? 'bg-yellow-600 text-white' 
                  : 'bg-white text-gray-600 hover:bg-gray-100'
              }`}
            >
              Consulting
            </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-20">
            {filteredServices.map((service) => (
              <div key={service.id} className="group relative">
                <div className="flex items-center mb-6">
                  <div className="text-yellow-600 mr-4">
                    {service.icon}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900">{service.title}</h3>
                </div>
                <p className="text-gray-600 mb-4 pl-10">
                  {service.description}
                </p>
                {/* <a href="#" className="text-yellow-600 hover:text-yellow-700 font-medium inline-flex items-center group pl-10">
                  Learn More <ArrowRight size={16} className="ml-1 transition-transform group-hover:translate-x-1" />
                </a> */}
                <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-yellow-400 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Products Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Premium Metal Products</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We deal exclusively in the highest quality precious metals from trusted refineries worldwide.
            </p>
          </div>
          
          {/* Product Tabs */}
          <div className="mb-8">
            <div className="flex justify-center space-x-4 border-b border-gray-200">
              <button 
                className={`py-2 px-4 font-medium transition-colors ${activeServiceTab === 'gold' ? 'text-yellow-600 border-b-2 border-yellow-600' : 'text-gray-600 hover:text-yellow-600'}`}
                onClick={() => setActiveServiceTab('gold')}
              >
                Gold
              </button>
              <button 
                className={`py-2 px-4 font-medium transition-colors ${activeServiceTab === 'silver' ? 'text-yellow-600 border-b-2 border-yellow-600' : 'text-gray-600 hover:text-yellow-600'}`}
                onClick={() => setActiveServiceTab('silver')}
              >
                Silver
              </button>
            </div>
          </div>
          
          {/* Product Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {activeServiceTab === 'gold' ? (
              // Gold Products
              <>
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                  <img src={goldbar} alt="Gold Bars" className="w-full h-48 object-cover" />
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Gold Bullion Bars</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      99.99% pure gold bars available in various weights from leading refineries.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-yellow-600 font-medium">Variable Prizing</span>
                      <button className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-1 px-2 rounded transition-colors">
                        Details
                      </button>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                  <img src={goldcoin} alt="Gold Coins" className="w-full h-48 object-cover" />
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Gold Sovereign Coins</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      Official gold coins from government mints around the world.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-yellow-600 font-medium">Variable Prizing</span>
                      <button className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-1 px-2 rounded transition-colors">
                        Details
                      </button>
                    </div>
                  </div>
                </div>
                

                
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                  <img src={goldjwellery} alt="Gold Jewelry" className="w-full h-48 object-cover" />
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Gold Alloys</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      Gold alloys in various purities for jewelry and industrial applications.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-yellow-600 font-medium">Variable Pricing</span>
                      <button className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-1 px-2 rounded transition-colors">
                        Details
                      </button>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              // Silver Products
              <>
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                  <img src={silverbar} alt="Silver Bars" className="w-full h-48 object-cover" />
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Silver Bullion Bars</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      999 fine silver bars in various weights from trusted refineries.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600 font-medium">Variable Prizing</span>
                      <button className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-1 px-2 rounded transition-colors">
                        Details
                      </button>
                    </div>
                  </div>
                </div>
                
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                  <img src={silvercoin} alt="Silver Coins" className="w-full h-48 object-cover" />
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Silver Coins</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      Collectible and investment silver coins from global mints.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600 font-medium">Variable Prizing</span>
                      <button className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-1 px-2 rounded transition-colors">
                        Details
                      </button>
                    </div>
                  </div>
                </div>
                
               
                
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                  <img src={silverjwellery} alt="Industrial Silver" className="w-full h-48 object-cover" />
                  <div className="p-4">
                    <h3 className="text-lg font-bold text-gray-900 mb-2">Industrial Silver</h3>
                    <p className="text-gray-600 text-sm mb-4">
                      Silver compounds and specialized products for industrial use.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-gray-600 font-medium">Variable Pricing</span>
                      <button className="text-xs bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-1 px-2 rounded transition-colors">
                        Details
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          
          
        </div>
      </section>
      
      {/* Testimonial Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">Trusted by Industry Leaders</h2>
            <p className="text-gray-300 max-w-2xl mx-auto">
              See what our clients have to say about our premium services and reliable operations.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Testimonial 1 */}
            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mr-3 text-lg font-bold">
                  JS
                </div>
                <div>
                  <h4 className="font-bold">James Smith</h4>
                 
                </div>
              </div>
              <p className="text-gray-300">
                "PVG Import Exports has been our trusted partner for over a decade. Their consistent reliability and market expertise have been invaluable to our operations."
              </p>
            </div>
            
            {/* Testimonial 2 */}
            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mr-3 text-lg font-bold">
                  ML
                </div>
                <div>
                  <h4 className="font-bold">Maria Lopez</h4>
                 
                </div>
              </div>
              <p className="text-gray-300">
                "The level of service and attention to detail we receive from PVG Import Exports is exceptional. Their global logistics solutions have streamlined our supply chain."
              </p>
            </div>
            
            {/* Testimonial 3 */}
            <div className="bg-gray-800 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mr-3 text-lg font-bold">
                  RK
                </div>
                <div>
                  <h4 className="font-bold">Robert Kim</h4>
               
                </div>
              </div>
              <p className="text-gray-300">
                "PVG Import Exports consistently delivers high-quality products on time and at competitive prices. Their market analysis has helped us optimize our purchasing strategy."
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-yellow-500 to-yellow-600 text-white">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="mb-8 md:mb-0 md:w-2/3">
              <h2 className="text-3xl font-bold mb-4">Ready to Start Trading?</h2>
              <p className="text-yellow-100 max-w-xl">
                Contact our experts today to discuss your precious metals import and export needs. We offer customized solutions for businesses of all sizes.
              </p>
            </div>
            <div>
                <Link to='/contact'>
              <button className="bg-white text-yellow-600 hover:bg-gray-100 font-bold py-3 px-6 rounded shadow-lg transition-colors">
                Request a Consultation
              </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
      
    </div>
       <Footer />
    </>
  )
}

export default GoldSilverWebsite

// import React, { useState, useEffect, useRef } from 'react';
// import { Globe, ArrowUpDown, ArrowRight, BarChart2, Phone, Mail, MapPin, ChevronDown, Menu, X, Shield, TrendingUp, Award, Clock, Users, DollarSign, Briefcase, Check, ShoppingCart, Star, MessageCircle, FileText, PieChart, ChevronRight, ChevronLeft, Lock, Info, Truck, ChartBar } from 'lucide-react';

// const GoldSilverWebsite = () => {
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState('gold');
//   const [scrolled, setScrolled] = useState(false);
//   const [goldPrice, setGoldPrice] = useState(2342.80);
//   const [silverPrice, setSliderPrice] = useState(27.65);
//   const [chartData, setChartData] = useState([]);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [showCalc, setShowCalc] = useState(false);
//   const [metalAmount, setMetalAmount] = useState(1);
//   const [metalType, setMetalType] = useState('gold');
//   const [calculatedValue, setCalculatedValue] = useState(2342.80);
//   const videoRef = useRef(null);

//   const modalRef = useRef(null);
  
//   // Handle scroll effect for navbar
//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 10) {
//         setScrolled(true);
//       } else {
//         setScrolled(false);
//       }
//     };
    
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   // Generate chart data
//   useEffect(() => {
//     const generateChartData = () => {
//       const goldData = [];
//       const silverData = [];
//       const today = new Date();
      
//       for (let i = 30; i >= 0; i--) {
//         const date = new Date();
//         date.setDate(today.getDate() - i);
//         const dateStr = `${date.getMonth() + 1}/${date.getDate()}`;
        
//         // Generate realistic looking price data
//         const goldBase = 2300 + Math.random() * 100;
//         const silverBase = 26 + Math.random() * 3;
        
//         goldData.push({
//           date: dateStr,
//           price: parseFloat(goldBase.toFixed(2))
//         });
        
//         silverData.push({
//           date: dateStr,
//           price: parseFloat(silverBase.toFixed(2))
//         });
//       }
      
//       setChartData({gold: goldData, silver: silverData});
//     };
    
//     generateChartData();
//   }, []);
  
//   // Simulate live price updates
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setGoldPrice(prev => +(prev + (Math.random() * 2 - 1) * 0.5).toFixed(2));
//       setSliderPrice(prev => +(prev + (Math.random() * 2 - 1) * 0.1).toFixed(2));
//     }, 5000);
    
//     return () => clearInterval(interval);
//   }, []);

//   // Auto advance carousel
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide(prev => (prev + 1) % 3);
//     }, 8000);
    
//     return () => clearInterval(interval);
//   }, []);

//   // Handle click outside modal
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (modalRef.current && !modalRef.current.contains(event.target)) {
//         setIsModalOpen(false);
//       }
//     };

//     if (isModalOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     } else {
//       document.removeEventListener('mousedown', handleClickOutside);
//     }

//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isModalOpen]);

//   // Handle calculator
//   useEffect(() => {
//     if (metalType === 'gold') {
//       setCalculatedValue((metalAmount * goldPrice).toFixed(2));
//     } else {
//       setCalculatedValue((metalAmount * silverPrice).toFixed(2));
//     }
//   }, [metalAmount, metalType, goldPrice, silverPrice]);

//   // Pause video when component unmounts
//   useEffect(() => {
//     return () => {
//       if (videoRef.current) {
//         videoRef.current.pause();
//       }
//     };
//   }, []);

//   const partners = [
//     "Swiss Gold Bank", "Global Precious Metals", "London Metal Exchange", 
//     "Tokyo Commodity Exchange", "New York Mercantile Exchange", "Dubai Gold & Commodities Exchange"
//   ];

//   const news = [
//     {
//       title: "PVG Import Exports Expands Operations to Africa",
//       date: "March 15, 2025",
//       excerpt: "Our company announces a strategic expansion into emerging African markets with new offices in Johannesburg and Cairo."
//     },
//     {
//       title: "Q1 Market Report Shows Record Gold Demand",
//       date: "March 2, 2025",
//       excerpt: "Our quarterly market analysis reveals unprecedented demand for gold bullion in Asian markets."
//     },
//     {
//       title: "PVG Import Exports Awarded ISO 9001:2024 Certification",
//       date: "February 20, 2025",
//       excerpt: "We're proud to announce our company has received the latest ISO certification for quality management systems."
//     }
//   ];

//   const testimonials = [
//     {
//       name: "James Smith",
//       position: "CEO, GoldTech Industries",
//       company: "GoldTech Industries",
//       image: "/api/placeholder/70/70",
//       text: "PVG Import Exports has been our trusted partner for over a decade. Their consistent reliability and market expertise have been invaluable to our operations."
//     },
//     {
//       name: "Maria Lopez",
//       position: "Director, Global Minerals Ltd.",
//       company: "Global Minerals Ltd.",
//       image: "/api/placeholder/70/70",
//       text: "The level of service and attention to detail we receive from PVG Import Exports is exceptional. Their global logistics solutions have streamlined our supply chain."
//     },
//     {
//       name: "Robert Kim",
//       position: "Procurement Manager, PreciousTech",
//       company: "PreciousTech",
//       image: "/api/placeholder/70/70",
//       text: "PVG Import Exports consistently delivers high-quality products on time and at competitive prices. Their market analysis has helped us optimize our purchasing strategy."
//     }
//   ];

//   const faqs = [
//     {
//       question: "What documentation is required for international gold trading?",
//       answer: "International gold trading requires several key documents including commercial invoice, packing list, certificate of origin, certificate of authenticity, shipping documents, insurance certificates, and compliance with anti-money laundering regulations. Our team handles all documentation to ensure smooth customs clearance."
//     },
//     {
//       question: "How do you ensure the security of precious metals during transport?",
//       answer: "We employ a multi-layered security approach including armored vehicles, GPS tracking, discrete packaging, armed security personnel, comprehensive insurance coverage, and secure chain of custody documentation. All shipments are fully insured against loss or damage."
//     },
//     {
//       question: "What are the minimum order quantities for your products?",
//       answer: "Minimum order quantities vary by product type. For gold bullion, our minimum order is 100 troy ounces. For silver bullion, the minimum is 1,000 troy ounces. For specialized products or industrial metals, please contact our sales team for specific requirements."
//     },
//     {
//       question: "How do you verify the authenticity of your precious metals?",
//       answer: "All our precious metals undergo rigorous authentication processes including XRF spectroscopy, ultrasonic testing, specific gravity testing, and verification of hallmarks. We only source from LBMA-approved refineries and provide certificates of authenticity with each purchase."
//     }
//   ];

//   const locations = [
//     { city: "London", address: "123 Financial St, London, UK", phone: "+44 20 1234 5678" },
//     { city: "New York", address: "456 Wall St, New York, USA", phone: "+1 212 987 6543" },
//     { city: "Zurich", address: "789 Gold Ave, Zurich, Switzerland", phone: "+41 44 123 4567" },
//     { city: "Singapore", address: "10 Marina Blvd, Singapore", phone: "+65 6123 4567" },
//     { city: "Dubai", address: "Gold Souk, Deira, Dubai, UAE", phone: "+971 4 123 4567" },
//     { city: "Hong Kong", address: "888 Exchange Sq, Central, Hong Kong", phone: "+852 2123 4567" }
//   ];
  
//   return (
//     <div className="flex flex-col min-h-screen bg-gray-50">
//       {/* Navigation - Enhanced with glass morphism effect */}
//       <header className={`fixed w-full z-50 transition-all duration-300 ${scrolled ? 'bg-white/90 backdrop-blur-md shadow-md py-2' : 'bg-transparent py-4'}`}>
//         <div className="container mx-auto px-4 flex justify-between items-center">
//           <div className="flex items-center">
//             <div className="mr-2 text-yellow-600">
//               <Globe size={28} />
//             </div>
//             <h1 className="text-xl font-bold bg-gradient-to-r from-yellow-500 to-gray-600 bg-clip-text text-transparent">
//               PVG Import ExportS
//             </h1>
//           </div>
          
//           {/* Desktop Navigation */}
//           <nav className="hidden md:flex items-center space-x-6">
//             <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium transition-all relative group">
//               Home
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-600 transition-all group-hover:w-full"></span>
//             </a>
//             <div className="relative group">
//               <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium transition-all flex items-center">
//                 Services <ChevronDown size={16} className="ml-1" />
//               </a>
//               <div className="absolute left-0 mt-2 w-48 bg-white shadow-xl rounded-lg overflow-hidden transform scale-0 group-hover:scale-100 opacity-0 group-hover:opacity-100 transition-all origin-top-left z-50">
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Import Services</a>
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Export Services</a>
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Market Analysis</a>
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Secure Logistics</a>
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Consulting</a>
//               </div>
//             </div>
//             <div className="relative group">
//               <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium transition-all flex items-center">
//                 Products <ChevronDown size={16} className="ml-1" />
//               </a>
//               <div className="absolute left-0 mt-2 w-48 bg-white shadow-xl rounded-lg overflow-hidden transform scale-0 group-hover:scale-100 opacity-0 group-hover:opacity-100 transition-all origin-top-left z-50">
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Gold Products</a>
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Silver Products</a>
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Specialty Metals</a>
//                 <a href="#" className="block px-4 py-2 text-sm text-gray-700 hover:bg-yellow-50 hover:text-yellow-600">Industrial Supply</a>
//               </div>
//             </div>
//             <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium transition-all relative group">
//               Market Data
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-600 transition-all group-hover:w-full"></span>
//             </a>
//             <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium transition-all relative group">
//               About
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-600 transition-all group-hover:w-full"></span>
//             </a>
//             <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium transition-all relative group">
//               Contact
//               <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-yellow-600 transition-all group-hover:w-full"></span>
//             </a>
//           </nav>
          
//           {/* Live Metal Prices with animation */}
//           <div className="hidden lg:flex items-center space-x-4">
//             <div className="flex items-center bg-gray-100 rounded-full px-4 py-1">
//               <span className="text-sm text-gray-700 mr-2">Gold:</span>
//               <span className="font-semibold text-yellow-600">${goldPrice}</span>
//               <span className={`ml-1 text-xs ${goldPrice % 2 > 1 ? 'text-green-500' : 'text-red-500'}`}>
//                 {goldPrice % 2 > 1 ? '↑' : '↓'}
//               </span>
//             </div>
//             <div className="flex items-center bg-gray-100 rounded-full px-4 py-1">
//               <span className="text-sm text-gray-700 mr-2">Silver:</span>
//               <span className="font-semibold text-gray-500">${silverPrice}</span>
//               <span className={`ml-1 text-xs ${silverPrice % 2 > 1 ? 'text-green-500' : 'text-red-500'}`}>
//                 {silverPrice % 2 > 1 ? '↑' : '↓'}
//               </span>
//             </div>
//             <button 
//               onClick={() => setIsModalOpen(true)}
//               className="bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-2 px-4 rounded-full shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5">
//               Request Quote
//             </button>
//           </div>
          
//           {/* Mobile Menu Button */}
//           <button 
//             className="md:hidden text-gray-800" 
//             onClick={() => setIsMenuOpen(!isMenuOpen)}
//           >
//             {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
//           </button>
//         </div>
        
//         {/* Mobile Menu - Enhanced with animations */}
//         {isMenuOpen && (
//           <div className="md:hidden bg-white shadow-lg animate-fadeIn">
//             <div className="container mx-auto px-4 py-3">
//               <div className="flex flex-col space-y-3">
//                 <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium py-2 border-b border-gray-100">Home</a>
//                 <div className="py-2 border-b border-gray-100">
//                   <div className="flex justify-between items-center">
//                     <span className="text-gray-800 font-medium">Services</span>
//                     <ChevronDown size={16} />
//                   </div>
//                   <div className="mt-2 pl-4 flex flex-col space-y-2">
//                     <a href="#" className="text-gray-600 hover:text-yellow-600">Import Services</a>
//                     <a href="#" className="text-gray-600 hover:text-yellow-600">Export Services</a>
//                     <a href="#" className="text-gray-600 hover:text-yellow-600">Market Analysis</a>
//                     <a href="#" className="text-gray-600 hover:text-yellow-600">Secure Logistics</a>
//                   </div>
//                 </div>
//                 <div className="py-2 border-b border-gray-100">
//                   <div className="flex justify-between items-center">
//                     <span className="text-gray-800 font-medium">Products</span>
//                     <ChevronDown size={16} />
//                   </div>
//                   <div className="mt-2 pl-4 flex flex-col space-y-2">
//                     <a href="#" className="text-gray-600 hover:text-yellow-600">Gold Products</a>
//                     <a href="#" className="text-gray-600 hover:text-yellow-600">Silver Products</a>
//                     <a href="#" className="text-gray-600 hover:text-yellow-600">Specialty Metals</a>
//                   </div>
//                 </div>
//                 <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium py-2 border-b border-gray-100">Market Data</a>
//                 <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium py-2 border-b border-gray-100">About</a>
//                 <a href="#" className="text-gray-800 hover:text-yellow-600 font-medium py-2 border-b border-gray-100">Contact</a>
//                 <div className="flex justify-between pt-2 border-t border-gray-200">
//                   <div className="flex items-center">
//                     <span className="text-sm text-gray-700 mr-1">Gold:</span>
//                     <span className="font-semibold text-yellow-600">${goldPrice}</span>
//                   </div>
//                   <div className="flex items-center">
//                     <span className="text-sm text-gray-700 mr-1">Silver:</span>
//                     <span className="font-semibold text-gray-500">${silverPrice}</span>
//                   </div>
//                 </div>
//                 <button 
//                   onClick={() => setIsModalOpen(true)}
//                   className="bg-yellow-600 hover:bg-yellow-700 text-white font-medium py-3 px-4 rounded shadow-md transition-colors">
//                   Request Quote
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </header>
      
//       {/* Hero Section - Enhanced with video background and parallax effect */}
//       <section className="pt-24 pb-16 md:pt-32 md:pb-24 relative overflow-hidden">
//         <div className="absolute inset-0 bg-black opacity-60 z-10"></div>
//         <div className="absolute inset-0 z-0">
//           <video 
//             ref={videoRef}
//             className="w-full h-full object-cover"
//             autoPlay 
//             muted 
//             loop 
//             playsInline
//           >
//             <source src="/api/placeholder/1000/600" type="video/mp4" />
//           </video>
//         </div>
//         <div className="container mx-auto px-4 relative z-20 text-white">
//           <div className="flex flex-col md:flex-row items-center">
//             <div className="md:w-3/5 mb-10 md:mb-0 animate-fadeInUp">
//               <div className="inline-block px-4 py-1 bg-yellow-600/80 rounded-full text-sm font-bold mb-6">
//                 INDUSTRY LEADER SINCE 1998
//               </div>
//               <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
//                 <span className="text-yellow-400">Premium</span> Gold & Silver <br />
//                 <span className="text-yellow-400">Import & Export</span> Solutions
//               </h1>
//               <p className="text-lg text-gray-200 mb-8 max-w-xl">
//                 Connecting global markets with secure, reliable, and competitive precious metals trading services for businesses worldwide.
//               </p>
//               <div className="flex flex-col sm:flex-row gap-4">
//                 <button className="bg-yellow-600 hover:bg-yellow-500 text-white font-medium py-3 px-8 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5">
//                   Our Services
//                 </button>
//                 <button className="bg-transparent border-2 border-white hover:bg-white/10 text-white font-medium py-3 px-8 rounded-full transition-colors">
//                   Learn More
//                 </button>
//               </div>
//             </div>
//             <div className="md:w-2/5 relative animate-fadeInRight">
//               <div className="bg-gradient-to-r from-yellow-500 to-yellow-600 p-1 rounded-lg shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500">
//                 <img src="/api/placeholder/600/400" alt="Gold bars and silver coins" className="rounded-lg" />
//               </div>
//               <div className="absolute -bottom-8 -left-8 bg-white text-black p-4 rounded-lg shadow-lg transform hover:scale-105 transition-transform">
//                 <div className="flex items-center gap-2">
//                   <ArrowUpDown className="text-yellow-600" />
//                   <span className="font-bold">24/7 Market Trading</span>
//                 </div>
//               </div>
//               <div className="absolute -top-8 -right-8 bg-white text-black p-4 rounded-lg shadow-lg transform hover:scale-105 transition-transform">
//                 <div className="flex items-center gap-2">
//                   <Globe className="text-yellow-600" />
//                   <span className="font-bold">Global Operations</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-gray-900 to-transparent z-10"></div>
//       </section>
      
//       {/* Quick Stats Bar */}
//       <section className="bg-yellow-600 py-4 shadow-md relative z-20">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-wrap justify-between items-center text-white">
//             <div className="w-full sm:w-auto flex items-center mb-2 sm:mb-0">
//               <TrendingUp size={18} className="mr-2" />
//               <span><strong>25+</strong> Years Experience</span>
//             </div>
//             <div className="w-full sm:w-auto flex items-center mb-2 sm:mb-0">
//               <Users size={18} className="mr-2" />
//               <span><strong>500+</strong> Global Clients</span>
//             </div>
//             <div className="w-full sm:w-auto flex items-center mb-2 sm:mb-0">
//               <Award size={18} className="mr-2" />
//               <span><strong>99.9%</strong> Client Satisfaction</span>
//             </div>
//             <div className="w-full sm:w-auto flex items-center">
//               <Globe size={18} className="mr-2" />
//               <span><strong>42</strong> Countries Served</span>
//             </div>
//           </div>
//         </div>
//       </section>
      
//       {/* About Section with Animated Numbers */}
//       <section className="py-16 bg-white">
//         <div className="container mx-auto px-4">
//           <div className="flex flex-col md:flex-row items-center">
//             <div className="md:w-1/2 mb-10 md:mb-0 pr-0 md:pr-12">
//               <div className="relative">
//                 <div className="absolute -top-6 -left-6 w-24 h-24 bg-yellow-100 rounded-lg z-0"></div>
//                 <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-gray-100 rounded-lg z-0"></div>
//                 <img src="/api/placeholder/600/400" alt="Company headquarters" className="rounded-lg shadow-lg relative z-10" />
//                 <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20 bg-yellow-600/90 text-white p-6 rounded-lg shadow-lg backdrop-blur-sm">
//                   <div className="text-center">
//                     <div className="text-4xl font-bold">$2.8B</div>
//                     <div className="text-sm">Annual Trade Volume</div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="md:w-1/2">
//               <div className="inline-block px-4 py-1 bg-yellow-100 text-yellow-600 rounded-full text-sm font-bold mb-4">
//                 ABOUT PVG Import ExportS
//               </div>
//               <h2 className="text-3xl font-bold text-gray-900 mb-6">
//                 Gold & Silver Trading <br />
//                 <span className="text-yellow-600">Excellence Since 1998</span>
//               </h2>
//               <p className="text-gray-600 mb-6">
//                 PVG Import Exports has established itself as a premier name in the global precious metals market, offering unparalleled import and export services for gold, silver, and other precious metals.
//               </p>
//               <p className="text-gray-600 mb-8">
//                 With our headquarters in London and offices in major financial centers across the world, we connect suppliers and buyers across continents, ensuring seamless transactions backed by our commitment to security, quality, and compliance.
//               </p>
              
//               <div className="grid grid-cols-2 gap-8 mb-8">
//                 <div className="flex items-start">
//                   <div className="mr-4 text-yellow-600">
//                     <Shield size={24} />
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-gray-900 mb-1">Secure Operations</h3>
//                     <p className="text-gray-600 text-sm">End-to-end security for all transactions and shipments</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="mr-4 text-yellow-600">
//                     <Award size={24} />
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-gray-900 mb-1">Certified Quality</h3>
//                     <p className="text-gray-600 text-sm">All products meet LBMA Good Delivery standards</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="mr-4 text-yellow-600">
//                     <Globe size={24} />
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-gray-900 mb-1">Global Network</h3>
//                     <p className="text-gray-600 text-sm">Connections with major markets and suppliers worldwide</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start">
//                   <div className="mr-4 text-yellow-600">
//                     <BarChart2 size={24} />
//                   </div>
//                   <div>
//                     <h3 className="font-bold text-gray-900 mb-1">Market Expertise</h3>
//                     <p className="text-gray-600 text-sm">In-depth analysis and market intelligence services</p>
//                   </div>
//                 </div>
//               </div>
              
//               <button className="bg-gray-900 hover:bg-black text-white font-medium py-3 px-6 rounded inline-flex items-center transition-colors">
//                 Company Profile <ArrowRight size={16} className="ml-2" />
//               </button>
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* Services Section - Enhanced with hover effects */}
//       <section className="py-20 bg-gray-50">
//         <div className="container mx-auto px-4">
//           <div className="text-center mb-16">
//             <div className="inline-block px-4 py-1 bg-yellow-100 text-yellow-600 rounded-full text-sm font-bold mb-4">
//               OUR PREMIUM SERVICES
//             </div>
//             <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Comprehensive Precious Metals Solutions</h2>
//             <p className="text-gray-600 max-w-2xl mx-auto">
//               We offer end-to-end services for precious metals trading, customized to meet the specific requirements of businesses across industries.
//             </p>
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {/* Service 1 */}
//             <div className="bg-white rounded-xl shadow-lg overflow-hidden group hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
//               <div className="h-40 bg-yellow-600 relative overflow-hidden">
//                 <div className="absolute inset-0 bg-gradient-to-r from-yellow-500 to-yellow-700 opacity-90"></div>
//                 <img src="/api/placeholder/400/300" alt="Import Export" className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-500" />
//                 <div className="absolute top-4 left-4 w-12 h-12 bg-white rounded-lg flex items-center justify-center">
//                   <ArrowUpDown className="text-yellow-600" size={24} />
//                 </div>
//               </div>
//               <div className="p-6">
//                 <h3 className="text-xl font-bold text-gray-900 mb-3">Import & Export</h3>
//                 <p className="text-gray-600 mb-6">
//                   Seamless cross-border precious metals trading with full compliance, documentation, and logistics support to navigate complex international regulations.
//                 </p>
//                 <ul className="mb-6 space-y-2">
//                   <li className="flex items-center text-sm text-gray-600">
//                     <Check size={16} className="text-yellow-600 mr-2" /> Cross
//                     </li>
//                     </ul>
//                     </div>
//                     </div>
//                     </div>
//                     </div>
//                     </section>
//                     </div>
//   )
// }
// export default GoldSilverWebsite